const NotFoundPage = () => {

    return (
        "404 Not found"
    )
}

export default NotFoundPage;